import React from 'react'
import './hero.scss'
import {motion} from "framer-motion"
import { Link } from 'react-router-dom'; 


const textVariants ={
    initial:{
        x:-500,
        opacity:0
    },
    animate:{
        x:0,
        opacity:1,
        transition:{
            duration:1,
            staggerChildren:0.1
        }
    },
    scrollButton:{
        opacity:0,
        y:10,
        transition:{
            duration:2,
            repeat:Infinity
        }
    }
}

const sliderVariants ={
  initial:{
      x:0,
  },
  animate:{
      x:"-220%",
      transition:{
          duration:20,
          repeat:Infinity,
          repeatType:"mirror"
      }
  },
}

const Hero = () => {
  return (
    <div className="hero">
      <div className="wrapper">
      <motion.div className="textContainer"  variants={textVariants} initial="initial" animate="animate" >
            <motion.h2  variants={textVariants}>Fueling Growth</motion.h2>
            <motion.h1  variants={textVariants}>Marketing That Works, Results That Last</motion.h1>

            <motion.div  variants={textVariants} className="buttons">
               <Link to="/casestudies"> <motion.button  variants={textVariants}>See the latest Work</motion.button></Link>
                <Link to="contact"><motion.button  variants={textVariants}>Contact Us</motion.button></Link>
            </motion.div>
            <motion.img  variants={textVariants} animate="scrollButton" src="/scroll.png" alt="" />
        </motion.div>
      </div>

      <motion.div className="slidingTextContainer"  initial="initial"  variants={sliderVariants} animate="animate">
      Driving Growth, Delivering Results
      </motion.div>



        <div className="imageContainer">
            <img src="/flyer.webp" alt="" />
        </div>
    </div>
  )
}

export default Hero
